var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-placeholder"},[_c('p',{staticClass:"text-center p-5"},[_vm._v(" PRACA MANUALNA ? ")])])
}]

export { render, staticRenderFns }